import React, { useEffect, useMemo, useRef, useState } from "react";
import 'cropperjs/dist/cropper.css'
import { CircularProgress, Grid, IconButton, Popper, Slider } from "@material-ui/core";
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import CircleIcon from "@material-ui/icons/RadioButtonUnchecked";
import CropLandscapeIcon from "@material-ui/icons/CropLandscape";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import Cropper from "cropperjs";

export const ProfileUploadCrop = ({ src, aspectRatio, shape, eventId, onCropped, onCancel }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [cropperInstance, setCropperInstance] = useState(null);
    const [zoomLevel, setZoomLevel] = useState(0);
    const [minZoomLevel, setMinZoomLevel] = useState(0);
    const imageRef = useRef();
    const wrapperRef = useRef();
    const convertedAspectRatio = useMemo(() => {
        var aspectRatioRegex = /(\d+) ?\/ ?(\d+)/i;
        if (aspectRatioRegex.test(aspectRatio)) {
            let matches = aspectRatioRegex.exec(aspectRatio);
            return matches[1] / matches[2];
        }
        else {
            return undefined;
        }
    }, [aspectRatio]);
    useEffect(() => {
        if (imageRef?.current) {
            imageRef.current.addEventListener("zoom", onZoomChanged)
        }
        return () => {
            if (imageRef?.current) {
                imageRef.current.removeEventListener("zoom", onZoomChanged)
            }
        }
    })
    useEffect(() => {
        initCropper();
    }, [])
    const onZoomChanged = ({ detail }) => {
        setZoomLevel(detail.ratio);
    }
    const initCropper = (movable, canvasData, rotation) => {
        setIsLoading(true);
        if (cropperInstance) cropperInstance.destroy();
        const cropInst = new Cropper(imageRef?.current, {
            viewMode: 0,
            dragMode: 'move',
            guides: true,
            autoCrop: true,
            autoCropArea: 1,
            cropBoxMovable: shape === "circle" ? true : false,
            initialAspectRatio: shape === "circle" ? 1 : (convertedAspectRatio ?? NaN),
            cropBoxResizable: false,
            toggleDragModeOnDblclick: false,
            minContainerHeight:10,
            minContainerWidth:10,
            responsive: false,
            ready: () => {
                if (canvasData) {
                    cropInst.setCanvasData(canvasData);
                }
                if (rotation) {
                    cropInst.rotateTo(rotation)
                }
                setMinZoomLevel(cropInst.getContainerData().height / cropInst.getCanvasData().naturalHeight)
                setIsLoading(false);
            }
        });
        setCropperInstance(cropInst);
    }
  
    const getCroppedImage = () => {
        if (shape === "circle") {
            const sourceCanvas = cropperInstance.getCroppedCanvas();
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            var width = sourceCanvas.width;
            var height = sourceCanvas.height;

            canvas.width = width;
            canvas.height = height;
            context.imageSmoothingEnabled = true;
            context.drawImage(sourceCanvas, 0, 0, width, height);
            context.globalCompositeOperation = 'destination-in';
            context.beginPath();
            context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
            context.fill();
            return canvas.toDataURL();
        }
        else {
            return cropperInstance.getCroppedCanvas().toDataURL();
        }
    }
 
    const handleZoomSlider = (event, newValue) => {
        if (newValue - zoomLevel != 0) {
            cropperInstance.zoom(newValue - zoomLevel);
        }
    }
    const zoomIn = () => {
        cropperInstance.zoom(0.1);
    }
    const zoomOut = () => {
        cropperInstance.zoom(-0.1);
    }
    const handleSave = () => {
        setIsLoading(true);
        const imageData = getCroppedImage();
        onCropped(imageData);
    }
    return <>
        <div ref={wrapperRef} className={shape === "circle" ? "rounded-crop" : ""} style={{ width: "100%", aspectRatio: aspectRatio }}>
            {isLoading ? <div style={{ position: "absolute", inset: 0, backgroundColor: "#0007", zIndex:5000 }}> <CircularProgress style={{ position: "absolute", inset: "calc(50% - 20px)" }} /> </div> : null}
            <img src={src} style={{ display: "block", width: "100%", aspectRatio: shape != "circle" ? aspectRatio : undefined }} ref={imageRef} />
        </div>
        {wrapperRef?.current ?
            <Popper id={+new Date()} open={true} anchorEl={wrapperRef?.current} placement="bottom" style={{ marginTop: "10px", zIndex: 1000, }}>
                <div className={`profile-crop-controls`} style={{ width: "fit-content", marginTop: 0, marginLeft: "auto", marginRight: "auto" }}>
                    <Grid container spacing={2} style={{ alignItems: "center" }}>
                        <Grid item>
                            <IconButton style={{ padding: "8px", margin: "0 5px" }} onClick={() => cropperInstance.rotate(-45)}>
                                <RotateLeftIcon tooltip="RotateImage" />
                            </IconButton>
                            <IconButton style={{ padding: "8px", margin: "0 5px" }} onClick={() => cropperInstance.rotate(45)}>
                                <RotateRightIcon tooltip="RotateImage" />
                            </IconButton>
                            {/* <IconButton style={{ padding: "8px", margin: "0 5px" }} onClick={() => setShape(shape === "circle" ? "normal" : "circle")}>
                                {shape != "circle" ? <CircleIcon tooltip="CircularShape" /> : <CropLandscapeIcon tooltip="NormalShape" />}
                            </IconButton> */}
                            <IconButton style={{ padding: "8px", margin: "0 5px" }} onClick={handleSave}>
                                <CheckIcon tooltip="SaveChanges" />
                            </IconButton>
                            <IconButton style={{ padding: "8px", margin: "0 5px" }} onClick={onCancel}>
                                <ClearIcon tooltip="Cancel" />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} alignItems="center" justify="space-between">
                        <Grid className="flex" item>
                            <IconButton style={{ padding: "8px" }} onClick={zoomOut}>
                                <ZoomOutIcon  />
                            </IconButton>
                        </Grid>
                        <Grid className="flex" item xs>
                            <Slider size="small" value={zoomLevel} min={minZoomLevel} max={2} step={0.01} onChange={handleZoomSlider} aria-labelledby="zoom-slider" />
                        </Grid>
                        <Grid className="flex" item>
                            <IconButton style={{ padding: "8px" }} onClick={zoomIn}>
                                <ZoomInIcon  />
                            </IconButton>
                        </Grid>
                    </Grid>
                </div>
            </Popper>
            : null}
    </>
}